export const ADD_MARKER_TO_FORMULA = 'ADD_MARKER_TO_FORMULA';
export const CANCEL_FORMULA_EDIT = 'CANCEL_FORMULA_EDIT';
export const GET_MARKERS = 'GET_MARKERS';
export const GET_MARKERS_FAIL = 'GET_MARKERS_FAIL';
export const GET_MARKERS_SUCCESS = 'GET_MARKERS_SUCCESS';
export const SET_AVAILABLE_MARKERS = 'SET_AVAILABLE_MARKERS';
export const SET_CURSOR_POSITION = 'SET_CURSOR_POSITION';
export const START_FORMULA_EDIT = 'START_FORMULA_EDIT';
export const UPDATE_FIELD = 'UPDATE_FIELD';
export const UPDATE_MARKER_LIST_FORMULA = 'UPDATE_MARKER_LIST_FORMULA';

export enum EFormulaType {
  BASE = 'Base',
  BATNA = 'BATNA',
  CAP = 'Cap',
  FLOOR = 'Floor',
}

export enum EFormulaModalType {
  ADDITIONAL_BATNAS = 'ADDITIONAL_BATNAS',
  BASE_BATNA = 'BASE_BATNA',
  CAP = 'CAP',
  FLOOR = 'FLOOR',
  PUSH = 'PUSH',
  PULL = 'PULL',
  PRICE_INDEX = 'PRICE_INDEX',
  CONTRACT_TERM = 'CONTRACT_TERM',
  COSTS = 'COSTS',
  FORMULA_LIST = 'FORMULA_LIST',
}

export enum ECurrencyByWeightType {
  CENTS_PER_POUND = '¢/lb',
  DOLLARS_PER_TON = '$/ton',
}

export interface IFormulaEntryState {
  modalType: EFormulaModalType | null;
  availableMarkers: IMarker[] | null;
  productIndex: number | null;
  markerList: IMarkerList[];
}

export interface IFormula {
  type: EFormulaModalType;
  error?: Error;
  formulaInputValue: string;
  active: boolean;
  cursorPosition: number;
}

export interface IMarker {
  dataSource: string;
  name: string;
  product: string;
  region: string;
  unit: string;
  isFavorite?: boolean;
  types?: string;
}

export interface IMarkerList {
  dataSource: string;
  name: string;
  originalUnit?: string;
  product: string;
  region: string;
  unit: string;
  isFavorite?: boolean;
  types?: string;
}
